import { render } from "./RefundViewerPage.vue?vue&type=template&id=f4f7c466&ts=true"
import script from "./RefundViewerPage.vue?vue&type=script&lang=ts"
export * from "./RefundViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__